import axios from "axios"
import AES from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'
import redux, { Dispatch, Reducer } from 'redux'
import { GRAPH_API } from "../config"
import { GetState } from './index'
import { QuoteState, reset } from './quote'

export interface LastScan {
  created: number
  decoded: any
  quote: QuoteState
}

export interface ScanState {
  last?: LastScan
  id?: string
  encoded?: any
  decoded?: any
  error?: any
}

type ActionTypes = 'SCAN_RESPONSE' | 'SCAN_DECODE' | 'SCAN_ERROR' | 'SCAN_LAST';
type Action = redux.Action<ActionTypes> & redux.AnyAction

const initialState: ScanState = {
  last: undefined,
  id: undefined,
  encoded: null,
  decoded: null,
  error: null,
}

export const actionTypes: {[key: string]: ActionTypes} = {
  LAST: 'SCAN_LAST',
  RESPONSE: 'SCAN_RESPONSE',
  DECODE: 'SCAN_DECODE',
  ERROR: 'SCAN_ERROR',
};

export const scan: Reducer<ScanState, Action> = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.RESPONSE:
      return Object.assign({}, state, {
        id: action.id,
        encoded: action.encoded,
        decoded: null,
        error: null,
      });

    case actionTypes.DECODE:
      return Object.assign({}, state, {
        decoded: action.decoded,
      });

    case actionTypes.LAST:
      return Object.assign({}, state, {
        last: action.last,
      });

    case actionTypes.ERROR:
      return Object.assign({}, state, {
        error: action.error,
        encoded: null,
        decoded: null,
      });

    default:
      return state
  }
};

export type decodeType = (key: string, pin: string) => any
export const decode = (key: string, pin: string) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  const state = getState();

  // just wait some time
  await new Promise(resolve => setTimeout(resolve, 2000))

  console.log('wuuut?', `${key}${pin}`)

  const raw = AES.decrypt(state.scan.encoded.data, `${key}${pin}`).toString(encUtf8);
  const data = JSON.parse(raw);

  await reset()(dispatch)

  await dispatch({
    type: actionTypes.DECODE,
    decoded: data,
  })
}

export type loadByIdType = (id: string) => any
export const loadById = (id: string) => async (dispatch: Dispatch<Action>, getState: GetState) => {
  console.log('try to load by id', id)

  try {
    const data = (await axios.get(`${GRAPH_API}/graphql?query={code:getCodeById(id:"${id}"){data}}`)).data.data.code;

    console.log('received data', data)

    dispatch({
      type: actionTypes.RESPONSE,
      id,
      encoded: data
    })
  } catch (e) {
    console.error('failed to load code', e)
    dispatch({
      type: actionTypes.ERROR,
      error: e.message
    })
  }
}

export const scanInitialize = () => async (dispatch: Dispatch<Action>) => {
  // await handleUser(userPool.getCurrentUser(), dispatch)
}
